import React from "react";
import Constants from "../../../configurations/constants";
import Formsy from "formsy-react";
import { DiscoverFields } from "../../../configurations/discoverConfigs/fields";
import TextInput from "../common/controls/TextInput";
import FormSelect from "../common/controls/Select";
import DatePickerWrapper from "../common/controls/DatePicker";
import { Permissioned } from "react-permissions";
import { connect } from "react-redux";
import Permissions from "../../../configurations/permissions";
import Util from "../../../util/util";
import { DiscoverConstants } from "../../../configurations/discoverConfigs/discoverConstants";

class CaseRequestFilter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      fromDate: null,
      endDate: null
    };
    this.onFromDateChange = this.onFromDateChange.bind(this);
    this.onToDateChange = this.onToDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onFromDateChange(date) {
    this.createdStartDate.props.setValue(
      date && date.startOf("day").format(Constants.DATE_FORMAT_LONG)
    );
    this.setState({
      fromDate: date && date.startOf("day")
    });
  }

  onToDateChange(date) {
    this.createdEndDate.props.setValue(
      date && date.endOf("day").format(Constants.DATE_FORMAT_LONG)
    );
    this.setState({
      endDate: date && date.endOf("day")
    });
  }

  handleSubmit(data) {
    this.props.onSearchHandler(data, true);
  }

  render() {
    const { fromDate, endDate } = this.state;
    return (
      <Formsy
        onValidSubmit={this.handleSubmit}
        ref="discoverCaseRequestFilter"
        noValidate
      >
        <div className="row">
          <div className="col-sm-10">
            <div className="row">
              <div className="col-md-4">
                <TextInput
                  name={DiscoverFields.caseNumber.name}
                  label={DiscoverFields.caseNumber.label}
                />
              </div>
              <div className="col-md-4">
                <FormSelect
                  name="requestType"
                  label="Request Type"
                  options={DiscoverConstants.CaseRequestTypeList}
                  valueKey="value"
                  labelKey="description"
                />
              </div>
              <div className="col-md-4">
                <FormSelect
                  name="status"
                  label="Status"
                  options={DiscoverConstants.CaseRequestStatusList}
                  valueKey="value"
                  labelKey="description"
                  value={DiscoverConstants.CaseRequestStatus.Declined}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <TextInput name="issuerCode" label="Issuer Code" />
              </div>
              <div className="col-md-4">
                <DatePickerWrapper
                  name="createdStartDate"
                  dateFormat={Constants.DATE_FORMAT}
                  label="Created Date (From)"
                  maxDate={endDate || 0}
                  disabledKeyboardNavigation={true}
                  peekNextMonth={true}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  readOnly={true}
                  innerRef={c => {
                    this.createdStartDate = c;
                  }}
                  dropdownMode="select"
                  selected={fromDate}
                  onChange={this.onFromDateChange}
                />
              </div>
              <div className="col-md-4">
                <DatePickerWrapper
                  name="createdEndDate"
                  minDate={fromDate}
                  maxDate={0}
                  dateFormat={Constants.DATE_FORMAT}
                  label="Created Date (To)"
                  disabledKeyboardNavigation={true}
                  peekNextMonth={true}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  readOnly={true}
                  innerRef={c => {
                    this.createdEndDate = c;
                  }}
                  dropdownMode="select"
                  selected={endDate}
                  onChange={this.onToDateChange}
                />
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary btn-block mt-20" type="submit">
              Search
            </button>
          </div>
        </div>
      </Formsy>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(CaseRequestFilter, [Permissions.VIEW_DISPUTE])
);



// WEBPACK FOOTER //
// ./src/components/discover/caseRequests/CaseRequestFilter.js